import axiosInstance from "./axiosInstance";
export const sendFundByUser = async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/fund/transfer`,payload);
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const getFundHistoryByUser = async (id,params={}) => {
  try {
    const response = await axiosInstance.get(`/api/fund/transfer/history/${id}`,{
        params:params
    });
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
